// General Median.co native bridge helpers (status bar + haptics).
// All no-ops in a normal browser — safe to call anywhere.

function bridge() {
  if (typeof window === "undefined") return null;
  return window.median || window.gonative || null;
}

export function isNativeApp() {
  return Boolean(bridge());
}

// Theme the native status bar to match the current RoyalChat Nova theme.
// Dark theme → light icons on the near-black bg; light theme → dark icons on white.
export function applyStatusBar(theme) {
  const b = bridge();
  if (!b?.statusbar?.set) return;
  const dark = theme !== "light";
  try {
    b.statusbar.set({
      style: dark ? "light" : "dark",
      color: dark ? "#0D0D0D" : "#FFFFFF",
      overlay: false,
    });
  } catch (e) { /* older bridge */ }
}

// Trigger a haptic tap. style ∈ impactLight|impactMedium|impactHeavy|
// notificationSuccess|notificationWarning|notificationError (Android also: tick|click|double_click)
export function haptic(style = "impactLight") {
  const b = bridge();
  if (!b?.haptics?.trigger) return;
  try { b.haptics.trigger({ style }); } catch (e) { /* plugin not enabled */ }
}
